import React from 'react'
import _ from 'lodash'

// DEV-2980: the storefront's "Show:" segmented control (cb-storefront
// plp/listing/Filter.tsx, .fb-seg), shared by the main toolbar and the sticky
// bar. Auction re-runs the listing search in place (the sticky bar's original
// logic, moved here); both bars pick the change up from the
// update-listing-filters event. Buy Now lives on the storefront, so it
// navigates there, as it always has; Sweepstakes goes to legacy's
// /sweepstakes page.

function storefront(path) {
  const endpoint = (typeof window !== 'undefined' && window.universal_variable && window.universal_variable.replatform_endpoint) || ''
  if (endpoint) window.location = `${endpoint.replace(/\/$/, '')}${path}`
}

export function buyingFormatOf(filters) {
  return (filters && filters.buying_format && filters.buying_format.code) || 'Auction'
}

function selectAuction(filters) {
  if (buyingFormatOf(filters) === 'Auction') return
  const next = _.cloneDeep(filters)
  next.buying_format.code = 'Auction'
  if (next.sort_by && next.sort_by.query) {
    // Mirror legacy sort_by reset when switching to Auction.
    next.sort_by.query.code = next.custom_sort_enabled ? 'pos:asc' : 'close_date:asc'
  }
  delete next.ab
  next.pagination.page = 1
  document.dispatchEvent(new CustomEvent('update-listing-filters', { detail: { filters: next } }))

  // Re-trigger a search via routing — same pattern as ListingFilters.search().
  const code = (next.sort_by && next.sort_by.query && next.sort_by.query.code) || ''
  const [sort_by, sort_direction] = code.split(':')
  const qs = `sort_direction=${sort_direction || ''}&sort_by=${sort_by || ''}&buying_format=${next.buying_format.code}`
  document.dispatchEvent(new CustomEvent('route-to', {
    detail: { url: `${location.pathname}?${qs}`, options: { trigger: true } }
  }))
}

export default function LotTypeSeg({ filters }) {
  const current = buyingFormatOf(filters)
  const types = [
    ['Auction', 'Auction', () => selectAuction(filters)],
    ['Buy It Now', 'Buy Now', () => storefront('/products/format/buy-now')],
    // Legacy's own sweepstakes page until the storefront's goes live.
    ['Sweepstakes', 'Sweepstakes', () => { window.location = '/sweepstakes' }],
  ]
  return (
    <div className="fb-seg" role="group" aria-label="Lot type">
      {types.map(([code, label, onClick]) => (
        <button
          key={code}
          type="button"
          className={current === code ? 'is-active' : ''}
          aria-pressed={current === code}
          onClick={onClick}
        >
          {label}
        </button>
      ))}
    </div>
  )
}
